import { embla } from "javascripts/webpage/embla";
import { showmore } from "javascripts/webpage/showmore";
import { tableOfContents } from "javascripts/webpage/table-of-contents";

document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector("#js-presses") && !document.querySelector("#js-preview_drafts")) {
    return;
  }
  showmore();
  tableOfContents();

  const emblaElements = embla("js-embla-slideshow-image", { fade: false, emblaOptions: { loop: false } });

  emblaElements.forEach(({ emblaApi, emblaElement }) => {
    const countNode = emblaElement.querySelector(".js-embla-slideshow-image");
    const slideCount = emblaApi.scrollSnapList().length;

    const updateCountDisplay = () => {
      const current = emblaApi.selectedScrollSnap();
      if (countNode) {
        countNode.textContent = `${current + 1} / ${slideCount}`;
      }

      const lastEvented = emblaElement.dataset.slideEvented ? parseInt(emblaElement.dataset.slideEvented, 10) : -1;

      if (current > lastEvented) {
        emblaElement.dataset.slideEvented = current;
        const s = window.s_gi?.(window.s_account);
        if (s) {
          s.linkTrackVars = "channel,prop1,prop35";
          s.linkTrackEvents = "None";
          s.channel = "画像スライド";
          s.prop1 = "画像スライド";
          s.prop35 = [emblaElement.dataset.id, current + 1, slideCount].join("_");
          s.tl(this, "o", s.prop1);
        }
      }
    };
    emblaApi.on("select", updateCountDisplay);
    emblaApi.on("reInit", updateCountDisplay);
    updateCountDisplay();
  });
});
